import React, { useEffect, useState } from "react";
import WebIcon from "@mui/icons-material/SpaceDashboardOutlined";
import TableIcon from "@mui/icons-material/TableView"
import RankingIcon from "@mui/icons-material/InsightsOutlined"
import { Box, FormControlLabel, FormGroup, Grid, Switch } from "@mui/material";
import PropTypes from "prop-types";
import { useLeftBar } from "../../context/LeftBar";
import { Header } from "./components/Header";
import NavItem from "./MenuItem/NavItem";
import MtrixLogoFooter from "../../assets/img/mtrixbrand.png";
import ArrowBackIosOutlinedIcon from "@mui/icons-material/ArrowBackIosOutlined";
import ArrowForwardIosOutlinedIcon from "@mui/icons-material/ArrowForwardIosOutlined";
import { useTour } from "@reactour/tour";

function LeftSideMenu({ app, config, logo }) {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [dataAtualizacao, setDataAtualizacao] = useState("");

  async function initialSelecao() {
    await app.variable.getContent("vAtualizacao", (reply) => {
      const data = reply.qContent.qString;
      setDataAtualizacao(data.substring(0, 15));
    });
  }

  useEffect(() => {
    initialSelecao();
    window.addEventListener("resize", () => setScreenWidth(window.innerWidth));

    return () => {
      window.removeEventListener("resize", () =>
        setScreenWidth(window.innerWidth)
      );
    };
  }, []);

  const { setIsOpen, setCurrentStep } = useTour();

  const startTutorial = () => {
    setCurrentStep(0)
    setIsOpen(true)
  }

  const openedTutorial = localStorage.getItem("opened-tutorial")

  useEffect(() => {
    if (!openedTutorial) {
      startTutorial()
    }
  }, [openedTutorial])

  const { leftBarOpened, setLeftBarOpened } = useLeftBar();

  return (
    <div className={leftBarOpened ? "leftSideMenu is-opened" : "leftSideMenu"}>
      <div className="containerLeftSideMenu">
        <Header leftBarOpened={leftBarOpened} />

        <div className="leftSideClientContainer">
          {leftBarOpened && <h2 className="titleSideCLient">MENU</h2>}
        </div>

        <div
          className={
            leftBarOpened
              ? "leftSideContent"
              : "leftSideContent leftSideContent-open"
          }
        >
          <ul>
            <NavItem
              muiIcon={<WebIcon />}
              name="Visão Geral"
              path="/overview"
            />

            <NavItem
              muiIcon={<RankingIcon />}
              name="Ranking"
              path="/ranking"
            />

            <NavItem
              muiIcon={<TableIcon />}
              name="Detalhamento"
              path="/details"
            />
          </ul>
        </div>

        <div
          className={
            leftBarOpened
              ? "leftSideContent leftSideContent-second"
              : "leftSideContent leftSideContent-second leftSideContent-open"
          }
        ></div>

        {leftBarOpened && (
          <Grid
            flexDirection={"row"}
            alignItems={"flex-start"}
            columnGap={1}
            className="leftSideFooter"
          >
            <Grid item>
              <Box
                component={"img"}
                src={MtrixLogoFooter}
                className="container-img-leftSide"
              />
              <div style={{
                display: "flex",
                direction: "column"
              }}>
                <span>Última atualização:</span>
              </div>
              <span>{dataAtualizacao}</span>
            </Grid>
          </Grid>
        )}
      </div>

      <div className="containerCloseSideMenu">
        <button
          type="button"
          onClick={() => {
            setLeftBarOpened(!leftBarOpened);
          }}
          className={leftBarOpened ? "" : "align-left"}
        >
          {leftBarOpened ? (
            <ArrowBackIosOutlinedIcon
              fontSize="small"
              sx={{ color: "#04477B" }}
            />
          ) : (
            <ArrowForwardIosOutlinedIcon
              fontSize="small"
              sx={{ color: "#04477B" }}
            />
          )}
        </button>
      </div>
    </div>
  );
}

LeftSideMenu.defaultProps = {
  app: null,
  config: null,
  logo: null,
};

LeftSideMenu.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
  logo: PropTypes.object,
};

export default LeftSideMenu;
